import React, {FC} from "react";
import {getPageNameByPageId, getUserId} from "../../../utils";
import {ReportItemsSearchPanel, ReportPage} from "../../../components";
import {ItemReportSearchParamsModel, PageEnum} from "../../../models";
import {searchReportItemsDifferentInCost} from "../../../serviceBroker/itemsReportApiServiceBroker";

export const ReportItemsDifferenceInCostPage: FC = () => {
    const initialState: ItemReportSearchParamsModel = {Lang: 1, userId: getUserId()};
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchReportItemsDifferentInCost}
            searchHeader={getPageNameByPageId(PageEnum.ReportItemsDifferentInCost)}
            SearchPanel={ReportItemsSearchPanel}
            formId={PageEnum.ReportItemsDifferentInCost}
        />
    );
};
